import React from 'react'
const SvgStep1 = props => (
  <svg id='step1_svg___tuceng_2' viewBox='0 0 60 60' {...props}>
    <defs>
      <style>{'.step1_svg__cls-1{fill:#fd5c1f}'}</style>
    </defs>
    <g id='step1_svg___tuceng_1-2'>
      <path
        className='step1_svg__cls-1'
        d='M30 2c15.44 0 28 12.56 28 28S45.44 58 30 58 2 45.44 2 30 14.56 2 30 2m0-2C13.43 0 0 13.43 0 30s13.43 30 30 30 30-13.43 30-30S46.57 0 30 0z'
      />
      <path
        className='step1_svg__cls-1'
        d='M30.47 31.36c0 1.51-.14 2.79-.41 3.83-.27 1.04-.66 1.88-1.16 2.51-.5.64-1.11 1.1-1.83 1.38-.71.28-1.52.42-2.42.42s-1.69-.14-2.41-.42-1.33-.74-1.84-1.38c-.51-.64-.9-1.48-1.18-2.51-.28-1.04-.42-2.31-.42-3.83v-2.82c0-1.51.14-2.78.41-3.81.27-1.02.67-1.85 1.17-2.48s1.12-1.08 1.83-1.35c.72-.27 1.52-.41 2.41-.41s1.71.14 2.42.41 1.33.72 1.84 1.35.9 1.45 1.17 2.48.41 2.29.41 3.81v2.82zm-2.35-3.21c0-1.04-.07-1.93-.22-2.65-.15-.73-.37-1.32-.67-1.77-.3-.45-.66-.78-1.1-.98-.44-.2-.94-.3-1.5-.3s-1.06.1-1.49.3c-.44.2-.8.53-1.09.98-.29.45-.51 1.04-.67 1.77s-.23 1.61-.23 2.65v3.58c0 1.03.08 1.92.23 2.66.15.74.38 1.35.68 1.82.3.47.67.82 1.1 1.04.44.22.93.33 1.49.33s1.08-.11 1.51-.33.79-.57 1.08-1.04c.29-.47.51-1.08.65-1.82s.22-1.63.22-2.66v-3.58zM41.2 39.24h-2.36V23.59l-4.74 1.74V23.2l6.73-2.53h.37v18.57z'
      />
      <path fill='none' stroke='#fd5c1f' strokeMiterlimit={10} strokeWidth={2} d='M8.79 8.79l42.42 42.42' />
    </g>
  </svg>
)
export default SvgStep1
